<template>
  <Day day="07.12.2025">
    <div slot="page-content">
      <h3>Geteert und gefedert (oder gestyroport)️</h3>
      <p>
        <img src="@/assets/day7.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day07',
  components: {
    Day
  }
}
</script>
